import { useEffect } from 'react';
export var useSetDeviceId = function useSetDeviceId(audioRef, sinkId) {
  useEffect(function () {
    if (!sinkId) {
      return;
    }

    if (!audioRef.current.setSinkId) {
      console.warn('HTMLAudioElement, setSinkId is not supported in this browser');
      return;
    }

    audioRef.current.setSinkId(sinkId);
  }, [audioRef, sinkId]);
};